import React, { useState } from 'react'
import { MOBILE_CAMERA_ID } from './cameraConfig'
import styles from './Vision.module.css'

const CameraStage = ({
    videoRef,
    overlayRef,
    mirrored,
    fps,
    devices = [],
    activeDeviceId,
    onSelectDevice,
    onToggleMirror,
    loading,
}) => {
    const [menuOpen, setMenuOpen] = useState(false)

    const choose = (id) => {
        onSelectDevice(id)
        setMenuOpen(false)
    }

    return (
        <div className={styles.stage}>
            <video
                ref={videoRef}
                className={styles.video}
                autoPlay
                playsInline
                muted
                style={{
                    transform: mirrored ? 'scaleX(-1)' : 'none',
                    // Show the whole phone frame (any orientation) instead of
                    // cropping it to the stage.
                    objectFit:
                        activeDeviceId === MOBILE_CAMERA_ID
                            ? 'contain'
                            : undefined,
                }}
            />
            <canvas ref={overlayRef} className={styles.overlay} />

            <div className={styles.fpsBadge}>FPS: {fps}</div>

            <div className={styles.camWrap}>
                <button
                    type="button"
                    className={styles.flipBtn}
                    onClick={() => setMenuOpen((v) => !v)}
                    aria-label="Choose camera"
                >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M4 7.5A1.5 1.5 0 015.5 6h2.2l1-1.6A1 1 0 019.6 4h4.8a1 1 0 01.9.4l1 1.6h2.2A1.5 1.5 0 0120 7.5v9A1.5 1.5 0 0118.5 18h-13A1.5 1.5 0 014 16.5v-9z"
                            stroke="currentColor"
                            strokeWidth="1.7"
                            strokeLinejoin="round"
                        />
                        <circle
                            cx="12"
                            cy="12"
                            r="3.2"
                            stroke="currentColor"
                            strokeWidth="1.7"
                        />
                    </svg>
                </button>

                {menuOpen && (
                    <>
                        <ul className={styles.camMenu}>
                            {devices.length === 0 && (
                                <li className={styles.camEmpty}>
                                    No cameras found
                                </li>
                            )}
                            {devices.map((d) => (
                                <li
                                    key={d.deviceId}
                                    className={`${styles.camItem} ${
                                        d.deviceId === activeDeviceId
                                            ? styles.camItemActive
                                            : ''
                                    }`}
                                    onClick={() => choose(d.deviceId)}
                                >
                                    {d.label}
                                </li>
                            ))}
                        </ul>
                        {onToggleMirror && (
                            <ul
                                className={`${styles.camMenu} ${styles.camMenuDetached}`}
                            >
                                <li
                                    className={`${styles.camItem} ${
                                        mirrored ? styles.camItemActive : ''
                                    }`}
                                    onClick={() => {
                                        onToggleMirror()
                                        setMenuOpen(false)
                                    }}
                                >
                                    Mirror: {mirrored ? 'On' : 'Off'}
                                </li>
                            </ul>
                        )}
                    </>
                )}
            </div>

            {loading && <div className={styles.loadingBadge}>Loading model…</div>}
        </div>
    )
}

export default CameraStage
